import JobExpand from "./JobExpand";
import TaskCardList from "./TaskCardList";
import {isTaskJob} from "./scheduler/schedulerUtils";

export default function ManageJobExpand({data, fieldWorkerMap, isLoading, onEditTask}) {
    if (isTaskJob(data)) {
        return (
            <TaskCardList
                defaultOpen
                job={data}
                fieldWorkerMap={fieldWorkerMap}
                isLoading={isLoading}
                onEditJob={() => onEditTask(data.cos_job_id)}
            />
        );
    }

    return <JobExpand data={data} />;
}
